import React, { useEffect, useState } from "react";
import api from "../../utils/api"; // your axios instance
import { toast } from "react-toastify";
import { showToast, editUserdata } from "../../helper/generalHelper";
import { useLocation } from "react-router-dom";

const AddBusiness = () => {
  const [formData, setFormData] = useState({
    businessName: "",
    contactNumber: "",
    currencyId: "",
    decimalPlaces: "",
    fullAddressText: "soon",
    line1: "",
    city: "",
    state: "",
    postalCode: "",
    country: 1,
    latitude: "13.0594115",
    longitude: "80.1751586",
    agree: false,
    isActive: 1,
    restaurantImages: [],
    restaurantDocuments: [{ name: "", file: null }],
  });

  const [currencies, setCurrencies] = useState([]);
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const basePath = location.pathname.includes('/restaurant-staff') ? '/restaurant-staff/employee' : '/restaurant';

  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const res = await api.get("restaurant/currency/all");
        setCurrencies(res.data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchCurrencies();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: Array.from(files),
    }));
  };

  const handleDocumentNameChange = (index, value) => {
    const updatedDocs = [...formData.restaurantDocuments];
    updatedDocs[index].name = value;
    setFormData((prev) => ({ ...prev, restaurantDocuments: updatedDocs }));
  };

  const handleDocumentFileChange = (index, file) => {
    const updatedDocs = [...formData.restaurantDocuments];
    updatedDocs[index].file = file;
    setFormData((prev) => ({ ...prev, restaurantDocuments: updatedDocs }));
  };

  const addDocumentRow = () => {
    setFormData((prev) => ({
      ...prev,
      restaurantDocuments: [...prev.restaurantDocuments, { name: "", file: null }],
    }));
  };

  const removeDocumentRow = (index) => {
    setFormData((prev) => ({
      ...prev,
      restaurantDocuments: prev.restaurantDocuments.filter((_, i) => i !== index),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.agree) {
      toast.error("Please agree to terms and conditions.");
      return;
    }

    setLoading(true);

    try {
      const data = new FormData();

      Object.keys(formData).forEach((key) => {
        if (
          key === "restaurantImages" ||
          key === "restaurantDocuments" ||
          key === "agree"
        )
          return;
        data.append(key, formData[key]);
      });

      formData.restaurantImages.forEach((file) =>
        data.append("restaurantImages[]", file)
      );
      
      formData.restaurantDocuments.forEach((doc) => {
        if (doc.file) {
          data.append("restaurantDocuments[]", doc.file);
          data.append("restaurantDocumentNames[]", doc.name || "Document");
        }
      });

      const res = await api.post("restaurant/restaurant/new", data, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      showToast(res);

      if (res.success) {
        // Write the new restaurantId into localStorage BEFORE redirect.
        // Sidebar reads getUserdata("restaurantId") to unlock features.
        // Without this the hard reload would still see null and stay locked.
        const newRestaurantId = res.data?.restaurantId;
        if (newRestaurantId) {
          editUserdata("restaurantId", newRestaurantId);
        }
        window.location.href = `${basePath}/business`;
      }
    } catch (error) {
      toast.error("Something went wrong while submitting.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gray-50">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-4xl bg-white rounded-lg shadow-lg p-8 space-y-6"
      >
        <h2 className="md:text-3xl font-bold text-center text-gray-800">
          Add New Business
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <input
            type="text"
            name="businessName"
            placeholder="Business Name"
            value={formData.businessName}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-4 py-2"
            required
          />
          <input
            type="tel"
            name="contactNumber"
            placeholder="Contact Number"
            value={formData.contactNumber}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-4 py-2"
            required
          />
          <select
            name="currencyId"
            value={formData.currencyId}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-4 py-2"
            required
          >
            <option value="">Select Currency</option>
            {Array.isArray(currencies) && currencies.map((currency) => (
              <option key={currency.id} value={currency.id}>
                {currency.name}
              </option>
            ))}
          </select>
          <select
            name="decimalPlaces"
            value={formData.decimalPlaces}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-4 py-2"
            required
          >
            <option value="">Decimal Places</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
          </select>
          <input
            type="text"
            name="line1"
            placeholder="Address Line 1"
            value={formData.line1}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-4 py-2"
            required
          />
          <input
            type="text"
            name="city"
            placeholder="City"
            value={formData.city}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-4 py-2"
            required
          />
          <input
            type="text"
            name="state"
            placeholder="State"
            value={formData.state}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-4 py-2"
            required
          />
          <input
            type="text"
            name="postalCode"
            placeholder="Postal Code"
            value={formData.postalCode}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-4 py-2"
            required
          />


          {/* File Inputs */}
          <div className="col-span-1 md:col-span-2">
            <label className="block font-medium text-gray-700 mb-1">
              Restaurant Images
            </label>
            <input
              type="file"
              name="restaurantImages"
              multiple
              onChange={handleFileChange}
              className="block w-full text-sm text-gray-600 border border-gray-300 rounded-md file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-primary file:text-white hover:file:bg-blue-600"
            />
          </div>

          <div className="col-span-1 md:col-span-2">
            <div className="flex justify-between items-center mb-2">
              <label className="font-medium text-gray-700">
                Restaurant Documents <span className="text-red-500">*</span>
              </label>
              <button
                type="button"
                onClick={addDocumentRow}
                className="text-sm bg-rose-50 text-rose-600 px-3 py-1 rounded-md font-semibold hover:bg-rose-100 transition-colors"
              >
                + Add Document
              </button>
            </div>
            
            <div className="space-y-3">
              {formData.restaurantDocuments.map((doc, index) => (
                <div key={index} className="flex flex-col sm:flex-row gap-3 items-center bg-gray-50 p-3 rounded-lg border border-gray-200">
                  <input
                    type="text"
                    placeholder="Document Name (e.g., FSSI)"
                    value={doc.name}
                    onChange={(e) => handleDocumentNameChange(index, e.target.value)}
                    className="flex-1 border border-gray-300 rounded px-3 py-2 text-sm"
                    required={index === 0}
                  />
                  <input
                    type="file"
                    accept=".pdf,image/*"
                    onChange={(e) => handleDocumentFileChange(index, e.target.files[0])}
                    className="flex-1 text-sm text-gray-600 border border-gray-300 rounded-md file:mr-4 file:py-1 file:px-3 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-primary file:text-white hover:file:bg-blue-600"
                    required={index === 0}
                  />
                  {formData.restaurantDocuments.length > 1 && (
                    <button
                      type="button"
                      onClick={() => removeDocumentRow(index)}
                      className="text-red-500 hover:bg-red-50 p-2 rounded-full transition-colors"
                      title="Remove Document"
                    >
                      ✕
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Terms & Conditions */}
        <div className="flex items-start gap-3 mt-4">
          <label className="flex items-start gap-3 cursor-pointer text-sm text-gray-600">
            <input
              type="checkbox"
              name="agree"
              checked={formData.agree}
              onChange={handleChange}
              className="mt-1"
              required
            />
            <span>
              I agree to the{" "}
              <a href="/terms" target="_blank" className="text-primary underline">
                Terms and Conditions
              </a>{" "}
              and{" "}
              <a href="/privacy" target="_blank" className="text-primary underline">
                Privacy Policy
              </a>
              .
            </span>
          </label>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-primary text-white py-3 rounded-md text-lg font-semibold hover:bg-blue-700 disabled:bg-gray-400 transition duration-200"
        >
          {loading ? "Submitting..." : "Submit"}
        </button>
      </form>
    </div>
  );
};

export default AddBusiness;
